// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GzhldeMyVPt0UZlxs0Mc{margin-left:7px;font-size:10px}`, "",{"version":3,"sources":["webpack://./Scripts/app/components/estilos-reutilizaveis/tipografia.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CACA,cAAA","sourcesContent":[".dicaUsuario {\r\n  margin-left: 7px;\r\n  font-size: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dicaUsuario": `GzhldeMyVPt0UZlxs0Mc`
};
export default ___CSS_LOADER_EXPORT___;
